module.exports = __webpack_public_path__ + "static/media/Pickaxe.a5f748c9.png";